import { getStorageItem, removeStorageItem, setStorageItem } from './storage';

/**
 * Lateralidade/substituição: a matrícula do gestor no lugar de quem as filas de apreciação agem. Quem grava (a
 * Home, a Minha Equipe na equipe lateral, o modal de férias) e quem lê (as filas) combinam só esta chave.
 *
 * Os pontos antigos ainda usam a string direto; os novos passam por aqui.
 */
const CHAVE = 'manager_lateralidade';

export function gravarLateralidade(matricula: string) {
  setStorageItem(CHAVE, matricula);
}

export function lerLateralidade(): string | null {
  return getStorageItem(CHAVE);
}

export function apagarLateralidade() {
  removeStorageItem(CHAVE);
}
